import Audience from 'models/audience';
import createConverter from './lib/create_converter';

export default createConverter(Audience);
